import { observer } from 'mobx-react';
import { OverviewVideoResource } from '../../../../../../components/ReqHlsVideo/Types';
import ExperienceVideoPreviewModalBody from '../../../../../../Native/AEP/Common/ProgramExperienceVideo/ExperienceVideoPreviewModalBody';
import { ExperienceDictionaryEntryResponse } from '../../../../../ExperiencesDictionary/Types';
import ExperienceVideoDetailsModalBody from './ExperienceVideoDetailsModalBody';
import { getVideoDetails } from '../../../../../../Native/AEP/Common/ProgramExperienceVideo/Types';
import { emptyFragment } from '@execonline-inc/execonline-ui';

interface Props {
  video: OverviewVideoResource;
  experienceResource: ExperienceDictionaryEntryResponse;
}

function VideoModal({ video, experienceResource }: Props) {
  return getVideoDetails(video)
    .map(({ video, sources }) => (
      <>
        <div className="-mt-14 flex-grow">
          <ExperienceVideoPreviewModalBody video={video} sources={sources.toArray()} />
        </div>
        <div className="relative sm:w-[19.875rem]">
          <ExperienceVideoDetailsModalBody experienceResource={experienceResource} />
        </div>
      </>
    ))
    .getOrElse(emptyFragment);
}

export default observer(VideoModal);
